<template>
    <div class="otp-edit-table">
        <el-table
            ref="moduleTable"
            border
            tooltip-effect="dark"
            v-loading="loading"
            :height="tableConfig.height"
            :data="tableData"
            :row-class-name="tableRowClassName"
            @selection-change="handleSelectionChange"
            @row-click='rowClick'
            @cell-dblclick="cellDblClick"
            >
            <el-table-column
                v-if="tableConfig.selectBtn"
                type="selection"
                width="40"
                fixed></el-table-column>
            <el-table-column
                :class-name="mustFill(item)"
                v-for="(item, index) in columnsList"
                :key="index"
                :prop='item.prop'
                :label="item.label"
                :sortable="item.sort"
                :show-overflow-tooltip="_.get(item, 'show-overflow-tooltip', true)"
                :min-width="_.get(item, 'width', '')">
                <template v-slot:header="scope">
                    <span>{{scope.column.label}}</span>
                    <el-tooltip v-if="item.info" effect="dark" placement="top">
                        <div slot="content" v-html="item.info"></div>
                        <i class="el-icon-question" style="color: #00BCBF"></i>
                    </el-tooltip>
                </template>
                <template v-slot="scope">
                    <div v-if='item.type === "photos"'>
                        <div v-if='scope.row.showPhotos' style="line-height: 0px;">
                            <img src="@/assets/photos.png" @click.stop='btnEvent(scope.row, "photos")' @dblclick.stop="" style="width: 20px; cursor: pointer;">
                        </div>
                        <div v-else-if="scope.row.noShowPhotos"></div>
                        <div v-else>
                            <el-button size="mini" type='text' @click.stop='btnEvent(scope.row, "upload", scope.$index)' @dblclick.stop="" v-if="tableConfig.leftOperation">
                                {{$translate('component.E202007310005', { defaultText: '上传' })}}
                            </el-button>
                            <el-button size="mini" type='text' @click.stop='btnEvent(scope.row, "photos", scope.$index)' @dblclick.stop=""
                            v-if="Array.isArray(scope.row.files) && scope.row.files.length">
                                {{$translate('component.E202007310005', { defaultText: '查看' })}}
                            </el-button>
                        </div>
                    </div>
                    <div style="display: flex;" v-else-if="scope.row.edit !== EDIT_TYPE.CANCEL && item.require">
                        <el-select
                            v-if="item.type === 'select'"
                            v-model="scope.row[item.prop]"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :clearable="_.get(item, 'clearable',true)"
                            :filterable="item.filterable"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            :multiple="_.get(item, 'multiple', false)"
                            :collapse-tags="_.get(item, 'collapseTags', false)"
                            :placeholder="item.name"
                            @change="(val) => elementChange(item.prop, val, scope.row, scope.$index)">
                            <el-option
                                v-for="(val, index) in _.get(scope.row, `${item.prop}Options`, item.options)"
                                :key=index
                                :label="val.label"
                                :value="val.value"
                            ></el-option>
                        </el-select>
                        <el-input
                            readonly
                            v-else-if="item.type === 'advance'"
                            v-model="scope.row[item.prop]"
                            :class="{'error-active': scope.row[`${item.prop}Error`] || _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            @keyup.113.native="detailSearch(scope.$index, item.prop, item, scope.row[item.prop], scope.row)"
                            @keyup.enter.native="detailSearch(scope.$index, item.prop, item, scope.row[item.prop], scope.row)">
                            <template v-slot:append>
                                <el-button
                                    icon="el-icon-search"
                                    :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                                    @click="detailSearch(scope.$index, item.prop, item, scope.row[item.prop], scope.row)"
                                ></el-button>
                            </template>
                            <template v-slot:suffix>
                                <i
                                    class="el-input__icon el-icon-circle-close"
                                    v-if="scope.row[item.prop]"
                                    @click="resetAdvanceParams(item.prop, scope.row, scope.$index)"
                                ></i>
                            </template>
                        </el-input>
                        <div v-else-if="item.type === 'customAdvance'" class="custom-advance">
                            <el-input
                                v-model="scope.row[item.prop]"
                                :class="{'error-active': scope.row[`${item.prop}Error`] || _.get(errorList, `[${scope.$index}][${index}]`)}"
                                :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                                @input="(val) => elementChange(item.prop, val, scope.row, scope.$index)">
                                <template v-slot:suffix>
                                    <i
                                        class="el-input__icon el-icon-circle-close"
                                        v-if="scope.row[item.prop]"
                                        @click="resetAdvanceParams(item.prop, scope.row, scope.$index)"
                                    ></i>
                                </template>
                            </el-input>
                            <el-tooltip v-if="scope.row[`${item.prop}Error`] && item.errorMessage" effect="dark" placement="top">
                                <div slot="content" v-html="item.errorMessage"></div>
                                <i class="el-icon-warning-outline"></i>
                            </el-tooltip>
                            <i
                                class="el-icon-user-solid"
                                :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                                @click="detailSearch(scope.$index, item.prop, item, scope.row[item.prop], scope.row)"
                            ></i>
                        </div>
                        <el-time-select
                            v-else-if="item.type === 'timeSelect'"
                            v-model="scope.row[item.prop]"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :clearable="_.get(item, 'clearable', true)"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            :picker-options="{
                                start: '01:00',
                                step: '01:00',
                                end: '24:00'
                            }"
                            :placeholder="item.placeholder ? item.placeholder : '选择时间'"
                            @change="(val) => elementChange(item.prop, val, scope.row, scope.$index)">
                        </el-time-select>
                        <el-input-number
                            v-else-if="item.type === 'inputNumber'"
                            v-model="scope.row[item.prop]"
                            :max="item.max === 0 ? 0 : (item.max || Infinity)"
                            :min="item.min === 0 ? 0 : (item.min || -Infinity)"
                            :step="item.step || 1"
                            :precision="item.precision || 0"
                            :step-strictly="item.stepStrictly || false"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            :controls="item.controls === undefined ? true : item.controls"
                            :controls-position="item.controlsPosition || '' "
                            @keyup.native="upNumber"
                            @keydown.native="upNumber"
                            @change="(val) => elementChange(item.prop, val, scope.row, scope.$index)"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                        ></el-input-number>
                        <el-input
                            v-else-if="item.type === 'inputInteger'"
                            :clearable="_.get(item, 'clearable',true)"
                            v-model.trim="scope.row[item.prop]"
                            oninput="value=value.replace(/^(0+)(\d)|[^\d]+/g,'')"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            @input="(val) => elementChange(item.prop, val, scope.row, scope.$index)"
                            :class="{'error-active': _.get(errorList, `[${scope.$index}][${index}]`)}"
                            maxlength="10"
                        ></el-input>
                        <div v-else-if="item.type === 'customInput'" class="custom-input">
                            <el-input
                                :clearable="_.get(item, 'clearable',true)"
                                :placeholder="item.placeholder"
                                v-model.trim="scope.row[item.prop]"
                                :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                                @input="(val) => elementChange(item.prop, val, scope.row, scope.$index)"
                                :class="{ 'error-active': scope.row[`${item.prop}Error`] || _.get(errorList, `[${scope.$index}][${index}]`)}"
                                :maxlength="item.maxLength || 255"
                            ></el-input>
                            <el-tooltip v-if="scope.row[`${item.prop}Error`] && item.errorMessage" effect="dark" placement="top">
                                <div slot="content" v-html="item.errorMessage"></div>
                                <i class="el-icon-warning-outline"></i>
                            </el-tooltip>
                        </div>
                        <el-input
                            :clearable="_.get(item, 'clearable',true)"
                            v-else
                            :type="item.type || 'text'"
                            :placeholder="item.placeholder"
                            v-model.trim="scope.row[item.prop]"
                            :disabled="scope.row[item.prop + 'Disabled'] || _columnIfDisabled(scope.row, item)"
                            @input="(val) => elementChange(item.prop, val, scope.row, scope.$index)"
                            :class="{'error-active': scope.row[item.prop] || _.get(errorList, `[${scope.$index}][${index}]`)}"
                            :maxlength="item.maxLength || 255"
                        ></el-input>
                    </div>
                    <template v-else>
                        <template >
                            {{item|initShow(scope.row)}}
                        </template>
                    </template>
                </template>
            </el-table-column>
            <el-table-column
                :label="$translate('component.E202006152352', { defaultText: '操作' })"
                fixed="right"
                align="center"
                v-if="tableConfig.leftOperation"
                :width="_.get(tableConfig, 'leftWidth', '')">
                <template v-slot="scope">
                    <el-button
                        size="mini"
                        :key="index"
                        :type=item.type
                        v-for="(item, index) in tableConfig.action"
                        @click.stop="btnEvent(scope.row,item.event, scope.$index)">
                        {{item.event !== 'edit' ? item.label : (scope.row.edit !== EDIT_TYPE.CANCEL? $translate('component.E202006152345', { defaultText: '取消' }) : item.label)}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <advance-dialog ref="advanceDialog"></advance-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from '@/components/lots/utils';
import { dictWithUrl } from '@/components/lots/api';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import { I18nMixins } from '@/components/utils/i18n';

export default {
    mixins: [I18nMixins],
    components: { advanceDialog },
    data() {
        return {
            EDIT_TYPE: { EDIT: 2, CANCEL: -3 },
            selectedRowsData: [],
            errorList: [],
            columnsList: this.tableConfig.columns,
            keyMap: {}
        };
    },
    props: {
        tableConfig: Object,
        tableData: {
            type: Array
        },
        loading: {
            type: Boolean,
            default() {
                return true;
            }
        },
        tableList: {
            type: String,
            default() {
                return '';
            }
        },
        type: {
            type: String,
            default: 'add'
        }
    },
    filters: {
        that: this,
        initShow(col, row) {
            if (row[col.prop] === 0) return 0;
            // 为空，为空数组时返回''
            if (!row[col.prop] || (_.isArray(row[col.prop]) && row[col.prop].length === 0)) {
                return '';
            }
            // 下拉框变为正常时显示值的改变
            let result = null;
            if (col.type === 'select') {
                if (_.isArray(row[col.prop])) {
                    result = row[col.prop].map(val => {
                        return _.get(col.options.find(item => item.value === val || item.label === val), 'label', '');
                    }).join(',');
                } else {
                    result = _.get(col.options.find(item => item.value === row[col.prop] || item.label === row[col.prop]), 'label', '');
                }
            } else {
                result = row[col.prop];
            }
            return result || '';
        }
    },
    methods: {
        detailSearch(index, prop, item, searchData, row) {
            if (!searchData) {
                searchData = '';
            }
            //  当前操作的行
            const currentOperateRow = this.tableData[index];
            const advanceCascade = {};
            // 高级搜索级联操作，current.advanceCascade为需要级联的参数的key的集合，例如advanceCascade: key1,key2,key3
            if (item && _.isString(item.advanceCascade)) {
                let advanceArray = [];
                advanceArray = item.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.tableData[index][sourceProp];
                });
            }
            // advanceRequire 作某个联动值的空值校验[{ 'prop': 'xxx', 'message': 'xxx' }]，prop为联动值字段，message为空值时输出信息
            const { mode, advanceRequire } = item;
            if (advanceRequire && advanceRequire.length > 0) {
                let flag = true;
                advanceRequire.forEach(ad => {
                    if (!this.tableData[index][ad.prop]) {
                        flag = false;
                        this.$message.warning(ad.message);
                    }
                });
                if (!flag) { return false; }
            }
            this.$refs.advanceDialog.show(true, item, advanceCascade, mode);
            this.$refs.advanceDialog.$once('confirm', (result) => {
                // 将返回数据添加到map里，用于高级搜索清空时，顺带清空其他关联属性
                const keyArr = Object.keys(result);
                if (keyArr.length > 0) {
                    keyArr.forEach(key => {
                        this.keyMap[key] = keyArr;
                    });
                }
                // Object.assign(currentOperateRow, result);
                Object.keys(result).forEach(key => {
                    this.$set(this.tableData[index], key, result[key]);
                });
                this.$emit('element-change', { val: _.clone(result), type: 'advance', row: currentOperateRow, prop, index });
            });
        },
        // 高级输入框的关闭按钮点击
        resetAdvanceParams(prop, row, index) {
            const keyArr = this.keyMap[prop];
            // 把属性相关联的字段置空
            _.isArray(keyArr) && keyArr.forEach(key => {
                row[key] = '';
                this.$set(this.tableData[index], key, '');
            });
            this.$set(this.tableData[index], prop, '');
            this.elementChange(prop, '', row, index);
        },
        elementChange (prop, val, row, index) {
            this.$emit('element-change', {
                prop,
                val,
                row,
                index
            });
        },
        // 只可输入数字
        upNumber (e) {
            e.target.value = e.target.value.replace(/[^\d]/g, '');
        },
        tableRowClassName({ row }) {
            // row.defaultRowClass 默认高亮
            if ((this.selectedRowsData && this.selectedRowsData.map(item => item.id).includes(row.id)) || row.defaultRowClass) {
                return 'highlight-row';
            }
        },
        _columnIfDisabled(row, col) {
            return _.isArray(row.disableProps) ? row.disableProps.includes(col.prop) : col.disabled;
        },
        clearSelection() {
            this.$refs.moduleTable.clearSelection();
        },
        selectionOne(checkedData) {
            this.$refs.moduleTable.toggleRowSelection(checkedData);
        },
        addRow() {
            // 新增一行，并进入行内编辑模式
            const obj = {};
            this.columnsList.forEach(item => {
                obj[item.prop] = item.defaultValue || '';
            });
            obj.edit = this.EDIT_TYPE.EDIT;
            this.tableData.push(obj);
            // 新增默认勾选
            this.$refs.moduleTable.toggleRowSelection(obj, true);
            // 新增返回值，用于手动修改新增的数据
            this.btnEvent(obj, 'addRowResponse');
        },
        handleSelectionChange (selection) {
            this.selectedRowsData = selection;
            this.$emit('onSelectionChange', selection);
        },
        btnEvent(selection, event, rowIndex) {
            if (event === 'edit') {
                // 状态取反
                const edit = ~selection.edit;
                if (selection.edit === this.EDIT_TYPE.EDIT) {
                    if (!selection.id) {
                        if (this.tableData.length <= 1) {
                            return this.$message.warning('至少保留一条明细');
                        }
                        this.tableData.splice(selection.serialNum, 1);
                    } else if (selection.backup) {
                        this.$refs.moduleTable.toggleRowSelection(selection, false);
                        this.$set(this.tableData, selection.serialNum, selection.backup);
                    }
                } else {
                    selection.backup = _.clone(selection);
                    this.$refs.moduleTable.toggleRowSelection(selection, true);
                }
                this.$set(this.tableData[rowIndex], 'edit', edit);
                this.$emit(`${event}-btn`, selection);
            } else {
                this.$emit(`${event}-btn`, selection, rowIndex);
            }
        },
        rowClick (rows) {
            if (!this.tableConfig.clickModify || rows.edit === this.EDIT_TYPE.EDIT) {
                return;
            }
            this.tableData[rows.serialNum].edit = this.EDIT_TYPE.EDIT;
            rows.backup = _.clone(rows);
            if (rows) {
                this.initRowBg(rows.serialNum);
                this.$refs.moduleTable.toggleRowSelection(rows, true);
            }
            this.$emit('row-click', rows);
        },
        /**
         * @description 双击复制单元格信息
         */
        cellDblClick (row, column, cell, event) {
            if (this.tableConfig.copyable) {
                if (row[column.property] === null || row[column.property] === undefined || row[column.property] === '') return;
                this.copyToClip(row[column.property]);
            }
        },
        copyToClip (txt) {
            var input = document.createElement('input');
            input.setAttribute('value', txt);
            document.body.appendChild(input);
            // 选择对象
            input.select();
            // 执行浏览器复制命令
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message.success(`‘${input.value}’复制成功`);
        },
        // 提供给外部使用，验证表单字段
        saveData (flag = true) {
            let ModifyData = this.tableData.map(item => {
                delete item.backup;
                return item;
            });
            if (!this.tableExamine(ModifyData, flag)) {
                ModifyData = false;
            } else {
                this.tableData.forEach(item => {
                    delete item.edit;
                });
            }
            return ModifyData;
        },
        // 表格提交验证
        tableExamine(data, flag) {
            let errorHint = false;
            let errorMsg = '';
            // 重置错误提醒对象
            this.errorList = this.tableData.map(item => {
                return Array(Object.keys(item).length).fill(false);
            });
            data.forEach(data => {
                this.columnsList.forEach((column, index) => {
                    const propIsNecessary = data.notNecessaryProps ? !data.notNecessaryProps.includes(column.prop) : column.mustFill;
                    if (propIsNecessary) {
                        if (data[column.prop] || data[column.prop] === 0) {
                            if (_.isArray(data[column.prop]) && data[column.prop].length === 0) {
                                this.errorList[data.serialNum][index] = errorHint = true;
                                errorMsg = this.$translate('component.E202011260008', { defaultText: '必填项不能为空' });
                            } else if (column.verify && !RegExp(column.verify).test(data[column.prop])) {
                                this.errorList[data.serialNum][index] = errorHint = true;
                                errorMsg = this.$translate('component.E202011260009', { defaultText: '部分选项格式不正确' });
                            }
                        } else {
                            this.errorList[data.serialNum][index] = errorHint = true;
                            errorMsg = this.$translate('component.E202011260008', { defaultText: '必填项不能为空' });
                        }
                    }
                });
            });
            if (errorHint && flag) {
                this.$message.error(errorMsg);
            }
            return !errorHint;
        },
        // 重新配置列宽度
        resetColumnWidth(columnsList) {
            this.columnsWidthConfig && Object.keys(this.columnsWidthConfig).forEach(key => {
                const col = columnsList.find(e => e.prop === key);
                if (col) {
                    col.width = this.columnsWidthConfig[key];
                }
            });
            return columnsList;
        },
        // 下拉框字典查询
        getOptionList(columnsList) {
            const optionList = [];
            const numList = [];
            columnsList.forEach((columns, index) => {
                if (columns.optionNum) {
                    optionList.push(columns.optionNum);
                    numList.push(index);
                }
            });
            if (optionList.length !== 0) {
                const params = {
                    dictCodes: optionList.join(','),
                    tenantCode: this.currentTenant.tenantCode
                };
                dictWithUrl(params).then(list => {
                    const optiondata = optionList.map(num => {
                        const option = [];
                        for (const key in list.data[num]) {
                            if (list.data[num].hasOwnProperty(key)) {
                                option.push({ 'value': key, 'label': _.get(list, `data.${num}.${key}`, '') });
                            }
                        }
                        return option;
                    });
                    numList.map((data, index) => {
                        columnsList[data].options = optiondata[index];
                    });
                });
            }
            this.columnsList = this.resetColumnWidth(columnsList);
        },
        dataInit(tableData) {
            const list = tableData || this.tableData;
            list.map((item, index) => {
                if (item.id && item.serialNum === undefined) {
                    this.$set(this.tableData[index], 'edit', this.EDIT_TYPE.EDIT);
                }
                item.serialNum = index;
                const errList = [];
                for (let i = 0; i < Object.keys(item).length; i++) {
                    errList.push(false);
                }
                this.$set(this.errorList, index, errList);
            });
            // 初始化keyMap
            this.columnsList.forEach(data => {
                if (data.type === 'advance' && _.isArray(data.cbParams)) {
                    const keys = data.cbParams.map(item => {
                        const arr = item.split('#');
                        return arr[1] || arr[0];
                    });
                    keys.forEach(key => {
                        this.keyMap[key] = keys;
                    });
                }
            });
            // this.initRowBg();
        },
        // 初始化行背景，并高亮指定行
        initRowBg (rowIndex = null) {
            const arr = document.getElementsByClassName('el-table__row');
            for (let i = 0; i < arr.length; i++) {
                arr[i].style.background = '';
            }
            if (rowIndex) {
                arr[rowIndex].style.background = '#F1F8FA';
            }
            return arr;
        }
    },
    watch: {
        tableData: function (val) {
            this.dataInit(val);
            this.getOptionList(this.tableConfig.columns);
            this.$forceUpdate();
        }
    },
    computed: {
        ...mapGetters(['currentTenant']),
        _() {
            return _;
        },
        mustFill() {
            return (item) => {
                return item.mustFill ? 'column-must-fill' : '';
            };
        }
    }
};
</script>
<style lang="less">
.otp-edit-table {
    .module-table {
        margin: 12px 0;
    }

    .el-table__body tr.selected-row > td {
        background: #F1F8FA !important;
    }
    .el-table__body tr.highlight-row {
        background: #e6f8f9;
    }

    .error-active input {
        border-color: red;
    }

    .error-active.date-picker {
        border-color: red;
    }

    .error-active .otpAllAddressSelect .el-cascader .el-input {
        border-color: red;
    }

    .demo .el-switch__label {
        position: absolute;
        display: none;
        color: #fff;
    }

    /*打开时文字位置设置*/

    .demo .el-switch__label--right {
        z-index: 1;
        right: -10px;
    }

    /*关闭时文字位置设置*/

    .demo .el-switch__label--left {
        z-index: 1;
        left: 26px;
    }

    /*显示文字*/

    .demo .el-switch__label.is-active {
        display: block;
    }

    .demo.el-switch .el-switch__core,
    .el-switch .el-switch__label {
        width: 60px !important;
    }

    .el-button--text {
        padding: 7px 0;
    }

    .has-gutter .column-must-fill {
        > div.cell::before {
            content: '*';
            color: red;
            font-size: 16px;
            margin-right: 5px;
        }
    }
    .el-icon-question {
        margin-left: 5px;
        font-size: 15px;
    }
    .custom-advance, .custom-input {
        display: flex;
        align-items: center;
        .el-icon-user-solid {
            margin-left: 5px;
            font-size: 14px;
            color: #00BCBF;
        }
        .el-icon-warning-outline {
            margin-left: 5px;
            font-size: 14px;
            color: red;
        }
        .el-input{
            flex: 1
        }
    }
}
</style>
